import React, { Component, Fragment } from 'react';

import { MContext } from '../../common/HelpProvider';

export default class PerkDetailsHelp extends Component {

    constructor(props) {
        super(props);
    }

    static get FocusType() {
        return {
            NONE: null,
            TITLE: 'title',
            CLAIMCONTENT: 'claimContent',
            MAXTOTALPERKCLAIM: 'maxtotalperkclaim'
        };
    }

    renderInitalPageHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Perk</h5>
                </div>
            </Fragment>
        );
    }

    renderTitleHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Perk</h5>
                </div>
            </Fragment>
        );
    }

    renderClaimContentHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Perk</h5>
                </div>
            </Fragment>
        );
    }

    renderMaxTotalPerkClaimHelp() {
        return (
            <Fragment>
                <p className="text-center">Example:</p>
                <img src="https://ik.imagekit.io/flair/tr:w-600,f-auto/Designer_Portal/Tips/Brand/brand_gXwm8H7M2" className="w-100 d-none" />
                <div className="mt-4 px-3">
                    <h5>Tip: Product Pricing</h5>
                </div>
            </Fragment>
        );
    }

    render() {
        const { focus } = this.props;
        return (
            <div className="sticky-top pt-5">
                <MContext.Consumer>
                    {(context) => (
                        <div>
                            {context.state.help === PerkDetailsHelp.FocusType.NONE &&
                                this.renderInitalPageHelp()
                            }
                            {context.state.help === PerkDetailsHelp.FocusType.TITLE &&
                                this.renderTitleHelp()
                            }
                            {context.state.help === PerkDetailsHelp.FocusType.CLAIMCONTENT &&
                                this.renderClaimContentHelp()
                            }
                            {context.state.help === PerkDetailsHelp.FocusType.MAXTOTALPERKCLAIM &&
                                this.renderMaxTotalPerkClaimHelp()
                            }
                        </div>
                    )}
                </MContext.Consumer>
            </div>
        );
    }
}
